"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlacesMatchingTags = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const usePlaces_1 = require("@opsbase/react-gql-hooks/place/usePlaces");
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const DataPill_1 = __importDefault(require("@opsbase/web-chips/DataPill"));
const Columns_1 = __importDefault(require("@opsbase/web-layout/Columns"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const IconMenu_1 = __importDefault(require("@opsbase/web-ui/IconMenu"));
const Spinner_1 = __importDefault(require("@opsbase/web-ui/Spinner"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importDefault(require("react"));
function PlacesMatchingTags(props) {
    const { tags, filterPlaces } = props;
    const { loading, data } = (0, usePlaces_1.usePlacesCollection)({
        variables: { tag: tags, limit: 9, id: filterPlaces === null || filterPlaces === void 0 ? void 0 : filterPlaces.map(f => f === null || f === void 0 ? void 0 : f.id), enabled: ['TRUE'] },
        skip: !(tags === null || tags === void 0 ? void 0 : tags.length),
    });
    if (!tags.length)
        return null;
    if (loading)
        return react_1.default.createElement(Spinner_1.default, { busy: true });
    const found = !!data.totalCount;
    const remaining = data.totalCount - data.items.length;
    return (react_1.default.createElement(IconMenu_1.default, { disabled: !found, small: true, color: found ? lib_palette_1.default.secondary : lib_palette_1.default.error, label: lib_i18n_1.default.t('places-found-matching-tags', { count: data.totalCount }), anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' } },
        react_1.default.createElement(Vertical_1.default, { gutter: true },
            react_1.default.createElement(Columns_1.default, { padding: true, gutter: true, noOfCols: 3 }, data.items.map((d, i) => (react_1.default.createElement(Pane_1.default, { key: 'place' + i },
                react_1.default.createElement(DataPill_1.default, { type: DataType_1.default.PLACE, value: d.title }))))),
            !!remaining && (react_1.default.createElement(Pane_1.default, { paddingX: true },
                react_1.default.createElement(Text_1.default, { color: "grey" },
                    lib_i18n_1.default.t('and-x-others', { x: remaining }),
                    "..."))))));
}
exports.PlacesMatchingTags = PlacesMatchingTags;
exports.default = PlacesMatchingTags;
